// ink-component
import React, { useEffect, useRef, useContext } from 'react';
import { SideNavContext } from '../../SideNavContext';
import getGlobalProps from '../../../../helpers/constants/global-props';
import { StyledSideNavContentContainer } from './styles';

export type SideNavContentContainerProps = React.HTMLAttributes<HTMLDivElement>;

/**
 * @purpose Standard content container to wrap the inner content of the SideNav
 * @group SideNav
 * @categories navigation
 * @HTMLType HTMLDivElement
 */
const SideNavContentContainer = (props: SideNavContentContainerProps) => {
  const { className, style, ...otherProps } = props;
  const { setScrolling } = useContext(SideNavContext);
  const globalProps = getGlobalProps({});

  // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
  const contentContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      const position = contentContainerRef.current?.scrollTop || 0;
      setScrolling(position > 0);
    };

    const contentContainerRefNode = contentContainerRef.current;
    if (contentContainerRefNode) {
      contentContainerRefNode.addEventListener('scroll', handleScroll, { passive: true });
    }

    return () =>
      contentContainerRefNode ? contentContainerRefNode.removeEventListener('scroll', handleScroll) : undefined;
  }, [contentContainerRef, setScrolling]);

  return <StyledSideNavContentContainer {...otherProps} {...globalProps} ref={contentContainerRef} />;
};

SideNavContentContainer.displayName = 'SideNav.ContentContainer';

export default SideNavContentContainer;
